export const PERSISTENT_STORAGE_IDENTIFIER_KEY = 'persistentStorageIdentifier';

// Used as functiona because this list is reused in waivers app
// Waivers app doesn't have SSR and constants define earlier
// That we load translation scripts
export const GET_COUNTRIES = () => [
  ['US', cT('"USA" acronym for United States of America', 'USA')],
  ['AF', T('Afghanistan')],
  ['AL', T('Albania')],
  ['DZ', T('Algeria')],
  ['AS', T('American Samoa')],
  ['AD', T('Andorra')],
  ['AO', T('Angola')],
  ['AI', T('Anguilla')],
  ['AG', T('Antigua and Barbuda')],
  ['AR', T('Argentina')],
  ['AM', T('Armenia')],
  ['AW', T('Aruba')],
  ['AC', T('Ascension Island')],
  ['AU', T('Australia')],
  ['AT', T('Austria')],
  ['AZ', T('Azerbaijan')],
  ['BS', T('Bahamas')],
  ['BH', T('Bahrain')],
  ['BD', T('Bangladesh')],
  ['BB', T('Barbados')],
  ['BY', T('Belarus')],
  ['BE', T('Belgium')],
  ['BZ', T('Belize')],
  ['BJ', T('Benin')],
  ['BM', T('Bermuda')],
  ['BT', T('Bhutan')],
  ['BO', T('Bolivia')],
  ['BA', T('Bosnia and Herzegovina')],
  ['BW', T('Botswana')],
  ['BR', T('Brazil')],
  ['IO', T('British Indian Ocean Territory')],
  ['VG', T('British Virgin Islands')],
  ['BN', T('Brunei')],
  ['BG', T('Bulgaria')],
  ['BF', T('Burkina Faso')],
  ['BI', T('Burundi')],
  ['KH', T('Cambodia')],
  ['CM', T('Cameroon')],
  ['CA', T('Canada')],
  ['CV', T('Cape Verde')],
  ['BQ', T('Caribbean Netherlands')],
  ['KY', T('Cayman Islands')],
  ['CF', T('Central African Republic')],
  ['TD', T('Chad')],
  ['CL', T('Chile')],
  ['CN', T('China')],
  ['CX', T('Christmas Island')],
  ['CC', T('Cocos (Keeling) Islands')],
  ['CO', T('Colombia')],
  ['KM', T('Comoros')],
  ['CD', T('Congo (DRC)')],
  ['CG', T('Congo (Republic)')],
  ['CK', T('Cook Islands')],
  ['CR', T('Costa Rica')],
  ['CI', T('Côte d’Ivoire')],
  ['HR', T('Croatia')],
  ['CU', T('Cuba')],
  ['CW', T('Curaçao')],
  ['CY', T('Cyprus')],
  ['CZ', T('Czech Republic')],
  ['DK', T('Denmark')],
  ['DJ', T('Djibouti')],
  ['DM', T('Dominica')],
  ['DO', T('Dominican Republic')],
  ['EC', T('Ecuador')],
  ['EG', T('Egypt')],
  ['SV', T('El Salvador')],
  ['GQ', T('Equatorial Guinea')],
  ['ER', T('Eritrea')],
  ['EE', T('Estonia')],
  ['SZ', T('Eswatini')],
  ['ET', T('Ethiopia')],
  ['FK', T('Falkland Islands (Malvinas)')],
  ['FO', T('Faroe Islands')],
  ['FJ', T('Fiji')],
  ['FI', T('Finland')],
  ['FR', T('France')],
  ['GF', T('French Guiana')],
  ['PF', T('French Polynesia')],
  ['GA', T('Gabon')],
  ['GM', T('Gambia')],
  ['GE', T('Georgia')],
  ['DE', T('Germany')],
  ['GH', T('Ghana')],
  ['GI', T('Gibraltar')],
  ['GR', T('Greece')],
  ['GL', T('Greenland')],
  ['GD', T('Grenada')],
  ['GP', T('Guadeloupe')],
  ['GU', T('Guam')],
  ['GT', T('Guatemala')],
  ['GG', T('Guernsey')],
  ['GN', T('Guinea')],
  ['GW', T('Guinea-Bissau')],
  ['GY', T('Guyana')],
  ['HT', T('Haiti')],
  ['HN', T('Honduras')],
  ['HK', T('Hong Kong')],
  ['HU', T('Hungary')],
  ['IS', T('Iceland')],
  ['IN', T('India')],
  ['ID', T('Indonesia')],
  ['IR', T('Iran')],
  ['IQ', T('Iraq')],
  ['IE', T('Ireland')],
  ['IM', T('Isle of Man')],
  ['IL', T('Israel')],
  ['IT', T('Italy')],
  ['JM', T('Jamaica')],
  ['JP', T('Japan')],
  ['JE', T('Jersey')],
  ['JO', T('Jordan')],
  ['KZ', T('Kazakhstan')],
  ['KE', T('Kenya')],
  ['KI', T('Kiribati')],
  ['XK', T('Kosovo')],
  ['KW', T('Kuwait')],
  ['KG', T('Kyrgyzstan')],
  ['LA', T('Laos')],
  ['LV', T('Latvia')],
  ['LB', T('Lebanon')],
  ['LS', T('Lesotho')],
  ['LR', T('Liberia')],
  ['LY', T('Libya')],
  ['LI', T('Liechtenstein')],
  ['LT', T('Lithuania')],
  ['LU', T('Luxembourg')],
  ['MO', T('Macau')],
  ['MG', T('Madagascar')],
  ['MW', T('Malawi')],
  ['MY', T('Malaysia')],
  ['MV', T('Maldives')],
  ['ML', T('Mali')],
  ['MT', T('Malta')],
  ['MH', T('Marshall Islands')],
  ['MQ', T('Martinique')],
  ['MR', T('Mauritania')],
  ['MU', T('Mauritius')],
  ['YT', T('Mayotte')],
  ['MX', T('Mexico')],
  ['FM', T('Micronesia')],
  ['MD', T('Moldova')],
  ['MC', T('Monaco')],
  ['MN', T('Mongolia')],
  ['ME', T('Montenegro')],
  ['MS', T('Montserrat')],
  ['MA', T('Morocco')],
  ['MZ', T('Mozambique')],
  ['MM', T('Myanmar')],
  ['NA', T('Namibia')],
  ['NR', T('Nauru')],
  ['NP', T('Nepal')],
  ['NL', T('Netherlands')],
  ['NC', T('New Caledonia')],
  ['NZ', T('New Zealand')],
  ['NI', T('Nicaragua')],
  ['NE', T('Niger')],
  ['NG', T('Nigeria')],
  ['NU', T('Niue')],
  ['NF', T('Norfolk Island')],
  ['KP', T('North Korea')],
  ['MK', T('North Macedonia')],
  ['MP', T('Northern Mariana Islands')],
  ['NO', T('Norway')],
  ['OM', T('Oman')],
  ['PK', T('Pakistan')],
  ['PW', T('Palau')],
  ['PS', T('Palestine')],
  ['PA', T('Panama')],
  ['PG', T('Papua New Guinea')],
  ['PY', T('Paraguay')],
  ['PE', T('Peru')],
  ['PH', T('Philippines')],
  ['PL', T('Poland')],
  ['PT', T('Portugal')],
  ['PR', T('Puerto Rico')],
  ['QA', T('Qatar')],
  ['RE', T('Réunion')],
  ['RO', T('Romania')],
  ['RU', T('Russia')],
  ['RW', T('Rwanda')],
  ['BL', T('Saint Barthélemy')],
  ['SH', T('Saint Helena')],
  ['KN', T('Saint Kitts and Nevis')],
  ['LC', T('Saint Lucia')],
  ['MF', T('Saint Martin')],
  ['PM', T('Saint Pierre and Miquelon')],
  ['VC', T('Saint Vincent and the Grenadines')],
  ['WS', T('Samoa')],
  ['SM', T('San Marino')],
  ['ST', T('São Tomé and Príncipe')],
  ['SA', T('Saudi Arabia')],
  ['SN', T('Senegal')],
  ['RS', T('Serbia')],
  ['SC', T('Seychelles')],
  ['SL', T('Sierra Leone')],
  ['SG', T('Singapore')],
  ['SX', T('Sint Maarten')],
  ['SK', T('Slovakia')],
  ['SI', T('Slovenia')],
  ['SB', T('Solomon Islands')],
  ['SO', T('Somalia')],
  ['ZA', T('South Africa')],
  ['KR', T('South Korea')],
  ['SS', T('South Sudan')],
  ['ES', T('Spain')],
  ['LK', T('Sri Lanka')],
  ['SD', T('Sudan')],
  ['SR', T('Suriname')],
  ['SJ', T('Svalbard and Jan Mayen')],
  ['SE', T('Sweden')],
  ['CH', T('Switzerland')],
  ['SY', T('Syria')],
  ['TW', T('Taiwan')],
  ['TJ', T('Tajikistan')],
  ['TZ', T('Tanzania')],
  ['TH', T('Thailand')],
  ['TL', T('Timor-Leste')],
  ['TG', T('Togo')],
  ['TK', T('Tokelau')],
  ['TO', T('Tonga')],
  ['TT', T('Trinidad and Tobago')],
  ['TN', T('Tunisia')],
  ['TR', T('Turkey')],
  ['TM', T('Turkmenistan')],
  ['TC', T('Turks and Caicos Islands')],
  ['TV', T('Tuvalu')],
  ['VI', T('U.S. Virgin Islands')],
  ['UG', T('Uganda')],
  ['UA', T('Ukraine')],
  ['AE', T('United Arab Emirates')],
  ['GB', T('United Kingdom (Great Britain)')],
  ['ZZ', T('Unknown or unspecified country')],
  ['UY', T('Uruguay')],
  ['UZ', T('Uzbekistan')],
  ['VU', T('Vanuatu')],
  ['VA', T('Vatican City')],
  ['VE', T('Venezuela')],
  ['VN', T('Vietnam')],
  ['WF', T('Wallis and Futuna')],
  ['EH', T('Western Sahara')],
  ['YE', T('Yemen')],
  ['ZM', T('Zambia')],
  ['ZW', T('Zimbabwe')],
  ['AX', T('Åland Islands')],
];

export const QR_CODE_SIZE = 256;
export const QR_CODE_COLOR = '#000000';

// Booking types for Notification and CannedMessage
export const BOOKING_TYPE_MAP = {
  BOOKING_CANCELLATION_TYPE: 'booking-cancellation',
  BOOKING_CONFIRMATION_TYPE: 'booking-confirmation',
  BOOKING_FOLLOW_UP_TYPE: 'booking-follow-up',
  BOOKING_MESSAGE_TYPE: 'booking-message',
  BOOKING_RECEIPT_TYPE: 'booking-receipt',
  BOOKING_REBOOKED_TYPE: 'booking-rebooked',
  BOOKING_REFUNDED_TYPE: 'booking-refunded',
};
export const BOOKING_TYPES = Object.values(BOOKING_TYPE_MAP);